import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout/Layout.jsx";
import Login from "./pages/Login.jsx";
import KandidatTest from "./pages/KandidatTest.jsx";
import SkoleniTest from "./pages/SkoleniTest.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import Weekly from "./pages/Weekly.jsx";
import Monthly from "./pages/Monthly.jsx";
import Yearly from "./pages/Yearly.jsx";
import Cashflow from "./pages/Cashflow.jsx";
import Marketing from "./pages/Marketing.jsx";
import AppReporting from "./pages/AppReporting.jsx";
import Stats from "./pages/Stats.jsx";
import Trainers from "./pages/Trainers.jsx";
import Clients from "./pages/Clients.jsx";
import LogExpired from "./pages/LogExpired.jsx";
import Permanentky from "./pages/Permanentky.jsx";
import Fakturace from "./pages/Fakturace.jsx";
import BootcampyPrehled from "./pages/bootcampy/Prehled.jsx";
import BootcampyKlienti from "./pages/bootcampy/Klienti.jsx";
import LogStBonus from "./pages/LogStBonus.jsx";
import LogPripsaneTreninky from "./pages/LogPripsaneTreninky.jsx";
import KlientVolno from "./pages/KlientVolno.jsx";
import LogCash from "./pages/LogCash.jsx";
import SmsSablony from "./pages/SmsSablony.jsx";
import Settings from "./pages/Settings.jsx";
import Automatizace from "./pages/Automatizace.jsx";
import Pravidla from "./pages/Pravidla.jsx";
import AuditLog from "./pages/AuditLog.jsx";
import Legal from "./pages/legal/Legal.jsx";
import UkolyHistorie from "./pages/UkolyHistorie.jsx";
import NakladyAI from "./pages/NakladyAI.jsx";
import WebMapa from "./pages/web/Mapa.jsx";
import WebAnalytika from "./pages/web/Analytika.jsx";
import AnalytikaPrehled from "./pages/analytika/Prehled.jsx";
import AnalytikaProdukty from "./pages/analytika/Produkty.jsx";
import AnalytikaReklamy from "./pages/analytika/Reklamy.jsx";
import AnalytikaReporty from "./pages/analytika/Reporty.jsx";
import WebZmeny from "./pages/web/Zmeny.jsx";
import SystemChangeLog from "./pages/system/ChangeLog.jsx";
import WebBlog from "./pages/web/Blog.jsx";
import ClientsAppPopupy from "./pages/clientsapp/Popupy.jsx";
import Feedback from "./pages/Feedback.jsx";
// Trenérská sekce — skeleton stránek pro přihlášené trenéry
import TrenerLayout from "./pages/trener/TrenerLayout.jsx";
import TrenerDashboard from "./pages/trener/Dashboard.jsx";
import TrenerKlienti from "./pages/trener/Klienti.jsx";
import TrenerUkoly from "./pages/trener/Ukoly.jsx";
import TrenerFakturace from "./pages/trener/Fakturace.jsx";
import TrenerDokumentDetail from "./pages/trener/DokumentDetail.jsx";
import TrenerRozvrhVzor from "./pages/trener/RozvrhVzor.jsx";
import SalesLayout from "./pages/sales/SalesLayout.jsx";
import SalesDnes from "./pages/sales/Dnes.jsx";
import SalesKontakty from "./pages/sales/Kontakty.jsx";
import SalesZkusebni from "./pages/sales/Zkusebni.jsx";
import SalesKontakt from "./pages/sales/Kontakt.jsx";
import SalesReport from "./pages/sales/SalesReport.jsx";
import B2bPrehled from "./pages/b2b/Prehled.jsx";
import B2bFirmy from "./pages/b2b/Firmy.jsx";
import B2bDetailFirmy from "./pages/b2b/DetailFirmy.jsx";
import B2bAkce from "./pages/b2b/Akce.jsx";
import B2bDetailAkce from "./pages/b2b/DetailAkce.jsx";
import B2bCenik from "./pages/b2b/Cenik.jsx";
import ManagerLayout from "./pages/manager/ManagerLayout.jsx";
import ManagerDashboard from "./pages/manager/Dashboard.jsx";
import CsmDashboard from "./pages/csm/Dashboard.jsx";
import TimeReport from "./pages/hr/TimeReport.jsx";
import ManagerUkoly from "./pages/manager/Ukoly.jsx";
import TreneriLayout from "./pages/manager/treneri/TreneriLayout.jsx";
import TrenerKalendar, { ManagerKalendar } from "./pages/trener/KalendarTrenera.jsx";
import Rezervace from "./pages/rezervace/Rezervace.jsx";
import Konzultace from "./pages/nutri/Konzultace.jsx";
import { ManagerRozvrh, ManagerRozvrhVzor } from "./pages/manager/TrenerRozvrh.jsx";
import ReportingLayout from "./pages/manager/reporting/ReportingLayout.jsx";
import Dokumenty from "./pages/Dokumenty.jsx";
// HR sekce — centrální evidence týmu (etapa 2: Lidé funkční, ostatní placeholder)
import HRLide from "./pages/hr/Lide.jsx";
import HRKandidati from "./pages/hr/Kandidati.jsx";
import HRSkoleni from "./pages/hr/HRSkoleni.jsx";
import MojeSkoleni from "./pages/MojeSkoleni.jsx";
import SalesRozvrhy from "./pages/sales/Rozvrhy.jsx";
import HodnoceniVyzivy from "./pages/sales/HodnoceniVyzivy.jsx";
import KnihaUrazu from "./pages/uraz/KnihaUrazu.jsx";
import UrazNovy from "./pages/uraz/UrazNovy.jsx";
import UrazDetail from "./pages/uraz/UrazDetail.jsx";
import UrazPotvrzeni from "./pages/UrazPotvrzeni.jsx";
import PodpisTablet from "./pages/PodpisTablet.jsx";
import PodpisTelefon from "./pages/PodpisTelefon.jsx";
import HRPodpisGmail from "./pages/hr/PodpisGmail.jsx";
import HRVyplaty from "./pages/hr/Vyplaty.jsx";
import HRRocniPrehled from "./pages/hr/RocniPrehled.jsx";
import HRUpominky from "./pages/hr/Upominky.jsx";
import HRBonusySrazky from "./pages/hr/BonusySrazky.jsx";
import HRAbsence from "./pages/hr/Absence.jsx";
// Operations sekce — company úkoly, meetingy, time tracking, CEO přehled (zatím jen owner)
import OperationsPrehled from "./pages/operations/Prehled.jsx";
import OperationsUkoly from "./pages/operations/Ukoly.jsx";
import OperationsMeetingy from "./pages/operations/Meetingy.jsx";
import OperationsTimeTracking from "./pages/operations/TimeTracking.jsx";
import NutriDashboard from "./pages/nutri/Dashboard.jsx";
import PdfJidelnicky from "./pages/nutri/PdfJidelnicky.jsx";
import MujUcet from "./pages/MujUcet.jsx";
import NavrhyReceptu from "./pages/nutri/NavrhyReceptu.jsx";
import VyzivaDatabaze from "./pages/vyziva/Databaze.jsx";
import KlubJidelnicek from "./pages/klub/Jidelnicek.jsx";
import KlubNavyky from "./pages/klub/Navyky.jsx";
import KlubClenove from "./pages/klub/Clenove.jsx";
import KlubAktivita from "./pages/klub/Aktivita.jsx";
import KlubDotazy from "./pages/klub/Dotazy.jsx";
import KlubClenstviLog from "./pages/klub/ClenstviLog.jsx";
import Denik from "./pages/Denik.jsx";
import { isAuthenticated, getCurrentUser, defaultPathForRole } from "./lib/auth.js";

// Vychozi landing dle role. Trener nema pristup na /dashboard (manazersky), proto
// musi mit vlastni domovskou routu, jinak se RequireAuth na /dashboard zacykli na sebe
// (Navigate to /dashboard -> role fail -> Navigate to /dashboard -> prazdna obrazovka).
// defaultPathForRole se přestěhoval do lib/auth.js, potřebuje ho i horní lišta.

// Domovska routa pro `/` index i catch-all `*` — presmeruje dle role (ne natvrdo /dashboard).
function RoleHome() {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  const user = getCurrentUser();
  return <Navigate to={defaultPathForRole(user?.role)} replace />;
}

function RequireAuth({ children, allowedRoles }) {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  if (allowedRoles && allowedRoles.length > 0) {
    const user = getCurrentUser();
    if (!user || !allowedRoles.includes(user.role)) {
      // Presmeruj na domovskou routu role (NE natvrdo /dashboard — zabrani smycce u trenera).
      return <Navigate to={defaultPathForRole(user?.role)} replace />;
    }
  }
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Veřejný test pro kandidáty na trenéra — bez přihlášení, jen s tokenem. */}
      <Route path="/test-trenera/:token" element={<KandidatTest />} />
      {/* Test skoleni pro tym — verejna stranka, autorizuje token (10.8.2026). */}
      <Route path="/skoleni/:token" element={<SkoleniTest />} />
      {/* Potvrzení záznamu o úrazu zraněnou osobou, odkaz z SMS (15. 10. 2026). */}
      <Route path="/u/:token" element={<UrazPotvrzeni />} />
      {/* Podpis smlouvy (3. 11. 2026): tablet z QR kódu trenéra, telefon klientky z SMS. Bez přihlášení, autorizuje token. */}
      <Route path="/podpis/:token" element={<PodpisTablet />} />
      <Route path="/p/:token" element={<PodpisTelefon />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<RoleHome />} />

        {/* Manažerské reporty — owner / manager / další role */}
        <Route path="dashboard" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><Dashboard /></RequireAuth>} />
        <Route path="weekly" element={<RequireAuth allowedRoles={["owner","manager"]}><Weekly /></RequireAuth>} />
        <Route path="monthly" element={<RequireAuth allowedRoles={["owner","manager"]}><Monthly /></RequireAuth>} />
        <Route path="yearly" element={<RequireAuth allowedRoles={["owner","manager"]}><Yearly /></RequireAuth>} />
        <Route path="cashflow" element={<RequireAuth allowedRoles={["owner"]}><Cashflow /></RequireAuth>} />
        <Route path="marketing" element={<RequireAuth allowedRoles={["owner","manager"]}><Marketing /></RequireAuth>} />
        <Route path="app-reporting" element={<RequireAuth allowedRoles={["owner"]}><AppReporting /></RequireAuth>} />
        <Route path="stats" element={<RequireAuth allowedRoles={["owner","manager"]}><Stats /></RequireAuth>} />
        <Route path="csm/dashboard" element={<RequireAuth allowedRoles={["owner","csm"]}><CsmDashboard /></RequireAuth>} />
        <Route path="clients" element={<RequireAuth allowedRoles={["owner","manager","csm","nutritionist"]}><Clients /></RequireAuth>} />
        <Route path="nutri/dashboard" element={<RequireAuth allowedRoles={["owner","manager","csm","nutritionist"]}><NutriDashboard /></RequireAuth>} />
        {/* Rezervace (29.9.2026) - vlastni rezervacni system: seznam a kalendar tymu; Konzultace = volno nutricni */}
        <Route path="rezervace" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><Rezervace /></RequireAuth>} />
        <Route path="nutri/konzultace" element={<RequireAuth allowedRoles={["owner","manager","csm","nutritionist"]}><Konzultace /></RequireAuth>} />
        <Route path="nutri/pdf-jidelnicky" element={<RequireAuth allowedRoles={["owner","manager","csm","nutritionist"]}><PdfJidelnicky /></RequireAuth>} />
        <Route path="nutri/navrhy-receptu" element={<RequireAuth allowedRoles={["owner","manager","csm","nutritionist"]}><NavrhyReceptu /></RequireAuth>} />
        {/* Databaze jidelnicku (22.8.2026, faze 2) - recepty a texty se schvalovanim */}
        <Route path="vyziva/databaze" element={<RequireAuth allowedRoles={["owner","manager","csm","nutritionist"]}><VyzivaDatabaze /></RequireAuth>} />
        {/* Klub (26.8.2026) - sdilene kaloricke urovne jidelnicku pro klub.fitway40.cz */}
        <Route path="klub/jidelnicek" element={<RequireAuth allowedRoles={["owner","nutritionist"]}><KlubJidelnicek /></RequireAuth>} />
        <Route path="klub/navyky" element={<RequireAuth allowedRoles={["owner","nutritionist"]}><KlubNavyky /></RequireAuth>} />
        {/* Clenove klubu (31.8.2026) - klub zamerne neni v `clients`, takze je nikde jinde videt neni. */}
        {/* Dotazy k živému vysílání (7.10.2026) - členky je posílají Martě předem z klubu. */}
        {/* Historie členství klubu (8.10.2026): co členky udělaly a co se samo provedlo ve FAPI. */}
        <Route path="klub/clenstvi" element={<RequireAuth allowedRoles={["owner"]}><KlubClenstviLog /></RequireAuth>} />
        <Route path="klub/dotazy" element={<RequireAuth allowedRoles={["owner","nutritionist"]}><KlubDotazy /></RequireAuth>} />
        <Route path="klub/clenove" element={<RequireAuth allowedRoles={["owner"]}><KlubClenove /></RequireAuth>} />
        <Route path="klub/aktivita" element={<RequireAuth allowedRoles={["owner", "csm"]}><KlubAktivita /></RequireAuth>} />
        {/* Denik uspechu (15.7.2026) - feed z klientske aplikace pro cely tym */}
        <Route path="denik" element={<RequireAuth allowedRoles={["owner","manager","csm","sales","trener","nutritionist"]}><Denik /></RequireAuth>} />
        <Route path="clients/log-expired" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><LogExpired /></RequireAuth>} />
        <Route path="clients/fakturace" element={<RequireAuth allowedRoles={["owner","csm"]}><Fakturace /></RequireAuth>} />
        <Route path="clients/permanentky" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><Permanentky /></RequireAuth>} />
        {/* Bootcamps (16.9.2026) — vlastní sekce menu, tři stránky. Klientky
            jsou provozní agenda, trenér do nich nechodí. */}
        <Route path="bootcampy" element={<RequireAuth allowedRoles={["owner","manager","csm","head_coach","trener","bc_trener"]}><BootcampyPrehled /></RequireAuth>} />
        <Route path="bootcampy/klienti" element={<RequireAuth allowedRoles={["owner","manager","csm","head_coach","bc_trener"]}><BootcampyKlienti /></RequireAuth>} />
        <Route path="clients/log-st-bonus" element={<RequireAuth allowedRoles={["owner","manager"]}><LogStBonus /></RequireAuth>} />
        <Route path="clients/log-pripsane-treninky" element={<RequireAuth allowedRoles={["owner","manager"]}><LogPripsaneTreninky /></RequireAuth>} />
        <Route path="clients/volno" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><KlientVolno /></RequireAuth>} />
        <Route path="log-cash" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><LogCash /></RequireAuth>} />
        <Route path="sms-sablony" element={<RequireAuth allowedRoles={["owner","manager"]}><SmsSablony /></RequireAuth>} />
        <Route path="settings" element={<RequireAuth allowedRoles={["owner"]}><Settings /></RequireAuth>} />
        <Route path="web/mapa" element={<RequireAuth allowedRoles={["owner"]}><WebMapa /></RequireAuth>} />
        <Route path="web/analytika" element={<RequireAuth allowedRoles={["owner","csm"]}><WebAnalytika /></RequireAuth>} />
        <Route path="analytika" element={<Navigate to="/analytika/prehled" replace />} />
        <Route path="analytika/prehled" element={<RequireAuth allowedRoles={["owner"]}><AnalytikaPrehled /></RequireAuth>} />
        <Route path="analytika/produkty" element={<RequireAuth allowedRoles={["owner"]}><AnalytikaProdukty /></RequireAuth>} />
        <Route path="analytika/reklamy" element={<RequireAuth allowedRoles={["owner"]}><AnalytikaReklamy /></RequireAuth>} />
        <Route path="analytika/reporty" element={<RequireAuth allowedRoles={["owner"]}><AnalytikaReporty /></RequireAuth>} />
        <Route path="system/changelog" element={<RequireAuth allowedRoles={["owner","manager"]}><SystemChangeLog /></RequireAuth>} />
        <Route path="web/zmeny" element={<RequireAuth allowedRoles={["owner","manager"]}><WebZmeny /></RequireAuth>} />
        <Route path="web/blog" element={<RequireAuth allowedRoles={["owner","manager"]}><WebBlog /></RequireAuth>} />
        <Route path="dokumenty" element={<RequireAuth allowedRoles={["owner","manager"]}><Dokumenty /></RequireAuth>} />
        <Route path="automatizace" element={<RequireAuth allowedRoles={["owner","manager"]}><Automatizace /></RequireAuth>} />
        <Route path="audit-log" element={<RequireAuth allowedRoles={["owner","manager"]}><AuditLog /></RequireAuth>} />
        <Route path="legal" element={<RequireAuth allowedRoles={["owner"]}><Legal /></RequireAuth>} />
        <Route path="naklady-ai" element={<RequireAuth allowedRoles={["owner"]}><NakladyAI /></RequireAuth>} />
        <Route path="clients-app/popupy" element={<RequireAuth allowedRoles={["owner"]}><ClientsAppPopupy /></RequireAuth>} />
        <Route path="feedback" element={<RequireAuth allowedRoles={["owner","manager"]}><Feedback /></RequireAuth>} />
        <Route path="pravidla" element={<RequireAuth allowedRoles={["owner"]}><Pravidla /></RequireAuth>} />

        {/* Operations — company úkoly, meetingy, time tracking, CEO přehled. Zatím jen owner,
            rozšíření na další role přijde později dle rozhodnutí ownera. */}
        <Route path="operations" element={<Navigate to="/operations/prehled" replace />} />
        <Route path="operations/prehled" element={<RequireAuth allowedRoles={["owner"]}><OperationsPrehled /></RequireAuth>} />
        {/* Úkoly (17.7.2026): dvě úrovně viditelnosti — Management (owner/manager/csm) vidí vše,
            Basic (sales/nutritionist) jen basic úkoly. Filtruje backend operations-ukoly.js. */}
        <Route path="operations/ukoly" element={<RequireAuth allowedRoles={["owner","manager","csm","sales","nutritionist","nutricni"]}><OperationsUkoly /></RequireAuth>} />
        {/* Meetingy (18.7.2026): owner + manager + CSM. Kvartál a rok filtruje backend jen na ownera. */}
        <Route path="operations/meetingy" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><OperationsMeetingy /></RequireAuth>} />
        {/* Historie úkolů (7.8.2026): kdo a kdy posunul deadline / přehodil pilota,
            napříč Operations i trenérskými úkoly. Citlivý pohled → jen owner. */}
        <Route path="operations/historie-ukolu" element={<RequireAuth allowedRoles={["owner"]}><UkolyHistorie /></RequireAuth>} />
        {/* Time tracking přesunutý z HR do Operations (owner pohled). Stránka je stejná
            komponenta jako /hr/time-report — pro ostatní role zůstává původní routa. */}
        {/* 14.7.2026: vlastní velká owner stránka (karty lidí, kvadranty, původ záznamů, náhled rozhraní). */}
        <Route path="operations/time-tracking" element={<RequireAuth allowedRoles={["owner"]}><OperationsTimeTracking /></RequireAuth>} />

        {/* Reporting — manažerský pohled na trenéry (přejmenované z /trainers) */}
        <Route path="reporting/treneri" element={<RequireAuth allowedRoles={["owner","manager"]}><Trainers /></RequireAuth>} />
        <Route path="trainers" element={<Navigate to="/reporting/treneri" replace />} />

        {/* HR sekce — Lidé (funkční), Bonusy + Zálohy + Dovolené (placeholder) */}
        <Route path="hr/time-report" element={<RequireAuth allowedRoles={["owner","manager","csm","sales","nutricni","nutritionist"]}><TimeReport /></RequireAuth>} />
        <Route path="hr/lide" element={<RequireAuth allowedRoles={["owner","manager"]}><HRLide /></RequireAuth>} />
        <Route path="hr/kandidati" element={<RequireAuth allowedRoles={["owner","manager"]}><HRKandidati /></RequireAuth>} />
        <Route path="hr/skoleni" element={<RequireAuth allowedRoles={["owner","manager"]}><HRSkoleni /></RequireAuth>} />
        {/* Kniha úrazů a Moje školení (15. 10. 2026). Trenér má obojí i ve svém portálu (/trener/...). */}
        <Route path="kniha-urazu" element={<RequireAuth allowedRoles={["owner","manager","csm","head_coach","trener","bc_trener"]}><KnihaUrazu /></RequireAuth>} />
        <Route path="kniha-urazu/novy" element={<RequireAuth allowedRoles={["owner","manager","csm","head_coach","trener","bc_trener"]}><UrazNovy /></RequireAuth>} />
        <Route path="kniha-urazu/:id" element={<RequireAuth allowedRoles={["owner","manager","csm","head_coach","trener","bc_trener"]}><UrazDetail /></RequireAuth>} />
        <Route path="moje-skoleni" element={<RequireAuth><MojeSkoleni /></RequireAuth>} />
        {/* 20. 10. 2026: vzorové rozvrhy trenérů pro sales, jen ke čtení. */}
        <Route path="rozvrhy-treneru" element={<RequireAuth allowedRoles={["sales","owner","manager"]}><SalesRozvrhy /></RequireAuth>} />
        {/* 1. 11. 2026: Hodnocení výživy, obvolávání klientek po nutriční konzultaci (sales, CSM, owner). */}
        <Route path="hodnoceni-vyzivy" element={<RequireAuth allowedRoles={["sales","csm","owner"]}><HodnoceniVyzivy /></RequireAuth>} />
        {/* 19.8.2026: generator jednotneho e-mailoveho podpisu pro tym. */}
        <Route path="hr/podpis" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><HRPodpisGmail /></RequireAuth>} />
        <Route path="hr/vyplaty" element={<RequireAuth allowedRoles={["owner"]}><HRVyplaty /></RequireAuth>} />
        {/* 24.8.2026: rocni prehledy prenesene z Google Sheetu (hlaseni z /feedback). */}
        <Route path="hr/dpp" element={<RequireAuth allowedRoles={["owner"]}><HRRocniPrehled typ="dpp" /></RequireAuth>} />
        <Route path="hr/naklady" element={<RequireAuth allowedRoles={["owner"]}><HRRocniPrehled typ="naklady" /></RequireAuth>} />
        <Route path="hr/upominky" element={<RequireAuth allowedRoles={["owner","manager"]}><HRUpominky /></RequireAuth>} />
        <Route path="hr/bonusy-srazky" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><HRBonusySrazky /></RequireAuth>} />
        {/* Legacy redirecty na sloucenou sekci (28.5.2026). Stare URL bookmarky a sidebar v cache. */}
        <Route path="hr/bonusy" element={<Navigate to="/hr/bonusy-srazky?typ=bonus" replace />} />
        <Route path="hr/zalohy-srazky" element={<Navigate to="/hr/bonusy-srazky?typ=srazka" replace />} />
        <Route path="muj-ucet" element={<RequireAuth><MujUcet /></RequireAuth>} />
        <Route path="hr/absence" element={<RequireAuth allowedRoles={["owner","manager","csm"]}><HRAbsence /></RequireAuth>} />
        <Route path="hr/dovolene" element={<Navigate to="/hr/absence" replace />} />
        {/* Moje výplata pro manager/csm (self-view, gated schválením) — trenér má vlastní /trener/fakturace */}
        <Route path="moje-vyplata" element={<RequireAuth allowedRoles={["owner","manager","csm","trener","head_coach","nutritionist"]}><TrenerFakturace /></RequireAuth>} />

        {/* Trenérská sekce — pro role owner (impersonace) + trener (jen své) */}
        <Route
          path="trener"
          element={
            <RequireAuth allowedRoles={["owner","trener"]}>
              <TrenerLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<TrenerDashboard />} />
          <Route path="kalendar" element={<TrenerKalendar />} />
          <Route path="rozvrh-vzor" element={<TrenerRozvrhVzor />} />
          <Route path="klienti" element={<TrenerKlienti />} />
          <Route path="ukoly" element={<TrenerUkoly />} />
          <Route path="fakturace" element={<TrenerFakturace />} />
          <Route path="dokumenty" element={<Navigate to="/trener/skoleni?sekce=dokumenty" replace />} />
          <Route path="dokumenty/:slug" element={<TrenerDokumentDetail />} />
          {/* Deník úspěchů uvnitř trenérské sekce (2.9.2026): na mobilu zůstává spodní menu a jde zpět. */}
          <Route path="denik" element={<Denik />} />
          <Route path="kniha-urazu" element={<KnihaUrazu />} />
          <Route path="kniha-urazu/novy" element={<UrazNovy />} />
          <Route path="kniha-urazu/:id" element={<UrazDetail />} />
          <Route path="skoleni" element={<MojeSkoleni />} />
        </Route>

        {/* B2B (20. 10. 2026, fáze 2): CRM firem. Jen owner a manažer, server role ověřuje znovu. */}
        <Route path="b2b" element={<Navigate to="/b2b/prehled" replace />} />
        <Route path="b2b/prehled" element={<RequireAuth allowedRoles={["owner","manager"]}><B2bPrehled /></RequireAuth>} />
        <Route path="b2b/firmy" element={<RequireAuth allowedRoles={["owner","manager"]}><B2bFirmy /></RequireAuth>} />
        <Route path="b2b/firma/:id" element={<RequireAuth allowedRoles={["owner","manager"]}><B2bDetailFirmy /></RequireAuth>} />
        <Route path="b2b/akce" element={<RequireAuth allowedRoles={["owner","manager"]}><B2bAkce /></RequireAuth>} />
        <Route path="b2b/akce/:id" element={<RequireAuth allowedRoles={["owner","manager"]}><B2bDetailAkce /></RequireAuth>} />
        <Route path="b2b/cenik" element={<RequireAuth allowedRoles={["owner","manager"]}><B2bCenik /></RequireAuth>} />

        {/* Sales sekce (30. 9. 2026): volání leadů, zkušební tréninky, bývalé klientky.
            Staré cesty (dashboard, volani, kapacita, leady) přesměrují na Dnes. */}
        <Route path="sales/report" element={<RequireAuth allowedRoles={["owner","manager"]}><SalesReport /></RequireAuth>} />
        <Route
          path="sales"
          element={
            <RequireAuth allowedRoles={["owner","manager","sales","csm"]}>
              <SalesLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="dnes" replace />} />
          <Route path="dnes" element={<SalesDnes />} />
          <Route path="kontakty" element={<SalesKontakty />} />
          <Route path="zkusebni" element={<SalesZkusebni />} />
          <Route path="kontakt/:id" element={<SalesKontakt />} />
          <Route path="dashboard" element={<Navigate to="/sales/dnes" replace />} />
          <Route path="volani" element={<Navigate to="/sales/dnes" replace />} />
          <Route path="kapacita" element={<Navigate to="/sales/dnes" replace />} />
          <Route path="leady" element={<Navigate to="/sales/kontakty" replace />} />
        </Route>

        {/* Manažer sekce — owner + manager. CSM má sem přístup JEN na Trenéři + Reporting
            (podstránky níže), manažerské-only stránky mají vlastní guard ["owner","manager"]. */}
        <Route
          path="manager"
          element={
            <RequireAuth allowedRoles={["owner","manager","csm"]}>
              <ManagerLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          {/* Podsekce Trenéři (zatím jen Úkoly; další odkryjeme postupně) */}
          <Route path="treneri" element={<TreneriLayout />}>
            <Route index element={<Navigate to="ukoly" replace />} />
            <Route path="ukoly" element={<ManagerUkoly />} />
            <Route path="reporting" element={<Trainers />} />
            <Route path="kalendar" element={<ManagerKalendar />} />
            <Route path="rozvrh" element={<ManagerRozvrh />} />
            <Route path="vzor" element={<ManagerRozvrhVzor />} />
          </Route>
          {/* Clients management — manažer vidí všechny klienty read-only (+ komentáře). Jen manažer (CSM má vlastní /clients). */}
          <Route path="clients" element={<RequireAuth allowedRoles={["owner","manager"]}><Clients /></RequireAuth>} />
          {/* Reporting — Přehled / Monthly / Yearly (jako CEO, cíle read-only) */}
          <Route path="reporting" element={<ReportingLayout />}>
            <Route index element={<Navigate to="monthly" replace />} />
            {/* Přehled přesunut nahoru jako samostatný Dashboard; starý odkaz přesměruj. */}
            <Route path="prehled" element={<Navigate to="/manager/dashboard" replace />} />
            <Route path="monthly" element={<Monthly />} />
            {/* Yearly report dočasně zamčený pro manažera (i přes URL) — redirect na monthly. */}
            <Route path="yearly" element={<Navigate to="/manager/reporting/monthly" replace />} />
          </Route>
          {/* Staré přímé routy zachované (kostry, zatím skryté v menu) */}
          <Route path="ukoly" element={<Navigate to="/manager/treneri/ukoly" replace />} />
          {/* Manažerské-only stránky — CSM sem nesmí (má jen Trenéři + Reporting).
              12.9.2026: Tým, Vyžaduje pozornost a Cíle měsíce byly kostry z Etapy 3
              bez dat, bez odkazu v menu, šlo se na ně dostat jen ručně zadanou
              adresou. Smazané, až budou potřeba, napíší se rovnou s daty. */}
          <Route path="dashboard" element={<RequireAuth allowedRoles={["owner","manager"]}><ManagerDashboard /></RequireAuth>} />
        </Route>
      </Route>
      <Route path="*" element={<RoleHome />} />
    </Routes>
  );
}
